"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var client_fetch_1 = require("@biw/client-fetch");
/******************
 * Initial state
 */
exports.onTheSpotState = {
    successMessage: false,
    errorMessage: '',
    success: false
};
/******************
 * Non-async action types
 */
exports.OTS_REDEEM = 'otsRedeem';
exports.SET_OTS_REDEEM_MESSAGE = 'setOtsRedeemMessage';
exports.SET_OTS_REDEEM_SUCCESS = 'setOtsRedeemSuccess';
/******************
 * Reducer
 */
function onTheSpotReducer(state, action) {
    if (state === void 0) { state = exports.onTheSpotState; }
    var _a;
    switch (action.type) {
        case exports.SET_OTS_REDEEM_SUCCESS:
            return tslib_1.__assign({}, state, { success: action.success });
        case exports.SET_OTS_REDEEM_MESSAGE:
            return tslib_1.__assign({}, state, (_a = {}, _a[action.messageType + 'Message'] = action.message, _a));
        default:
            return state;
    }
}
exports.onTheSpotReducer = onTheSpotReducer;
/*******************************************************************************
 * Action creators
 */
exports.setMessage = function (messageType, message) { return ({
    type: exports.SET_OTS_REDEEM_MESSAGE,
    messageType: messageType,
    message: message
}); };
exports.setSuccess = function (bool) { return ({
    type: exports.SET_OTS_REDEEM_SUCCESS,
    success: bool
}); };
exports.redeem = function (_a) {
    var code = _a.code, userName = _a.userName;
    return function (dispatch) {
        return client_fetch_1.clientFetch({
            url: '/api/v1.0/ots/redeem',
            type: exports.OTS_REDEEM,
            method: 'post',
            body: { code: code, userName: userName }
        }).then(function (response) {
            dispatch(exports.setSuccess(true));
            dispatch(exports.setMessage('success', { cmText: response.message, points: response.value }));
            return response;
        }).catch(function () { return false; });
    };
};
//# sourceMappingURL=dux.js.map